import React from 'react';
import { Check } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { howItWorks } from '../../data/content';
export function HowItWorksSection() {
  return <section className="bg-cream py-16 md:py-[84px]" data-id="element-98" data-mp="32dkokxwfdfg4">
      <div className="mx-auto max-w-[1120px] px-5" data-id="element-99" data-mp="36dur20l0dnq8">
        <SectionHeading kicker="Así de fácil" icon={Check} title={<>
              Lo usas <em data-id="element-101" data-mp="29lhjjm724sut">hoy mismo</em> en 3 pasos
            </>} data-id="element-100" data-mp="36dbaan73h5ds" />
        <ol className="mt-11 grid gap-5 md:grid-cols-3" data-id="element-102" data-mp="2en6smwapywg9">
          {howItWorks.map((s, i) => <li key={s.title} data-id="element-103" data-mp="2impfvyq0jjm9" data-mpi={i}>
              <Reveal delay={i * 0.05} className="h-full rounded-[22px] border border-line bg-white px-[26px] py-[30px]" data-id="element-104" data-mp="2imfme15reubt">
                <span className="mb-4 flex h-[52px] w-[52px] items-center justify-center rounded-full bg-tangerine font-display text-2xl font-extrabold text-white" data-id="element-105" data-mp="1qxma2eiha17i">
                  {i + 1}
                </span>
                <h3 className="text-xl font-semibold text-forest" data-id="element-106" data-mp="33cna9cveff3p">{s.title}</h3>
                <p className="mt-1.5 text-[15.5px] leading-relaxed text-muted" data-id="element-107" data-mp="2ydj2mqo4hpfh">{s.text}</p>
              </Reveal>
            </li>)}
        </ol>
      </div>
    </section>;
}